module.exports = __webpack_public_path__ + "Flag-600.b050ca391f065dfb15675be9c1b3310f.svg";